import React, { useState } from "react";
import { Button } from "../../../components/ui/button";
import { TextInput } from "../../../components/ui/FormControls";
import {
  addReminderDraft,
  CREDENTIAL_MAX_REMINDERS,
  CREDENTIAL_REMINDER_CHANNELS,
  initialReminderDrafts,
  removeReminderDraft,
  type ReminderDraft,
} from "../../../lib/credentialReminders";
import type { CredentialReminderSlot } from "../types";

type CredentialRemindersFieldsProps = {
  reminders?: CredentialReminderSlot[];
  confirmed?: boolean;
};

export const CredentialRemindersFields: React.FC<
  CredentialRemindersFieldsProps
> = ({ reminders, confirmed }) => {
  const [rows, setRows] = useState(() =>
    initialReminderDrafts(reminders, confirmed),
  );

  return (
    <div className="rounded-2xl border border-border p-4">
      <p className="mb-3 text-sm font-semibold text-foreground">Reminders</p>
      <input type="hidden" name="reminders_present" value="1" />
      {rows.map((row, index) => (
        <div
          key={row.key}
          className="mb-3 grid gap-3 sm:grid-cols-[7rem_max-content_auto] sm:items-center"
        >
          <TextInput
            name="reminders[][days_before]"
            type="number"
            min={1}
            max={365}
            value={row.daysBefore}
            onChange={(event) => {
              const next = event.target.value;
              setRows((current) =>
                current.map((item) =>
                  item.key === row.key ? { ...item, daysBefore: next } : item,
                ),
              );
            }}
            aria-label={`Reminder ${index + 1} days before`}
          />
          <select
            name="reminders[][channel]"
            value={row.channel}
            onChange={(event) => {
              const next = event.target.value as ReminderDraft["channel"];
              setRows((current) =>
                current.map((item) =>
                  item.key === row.key ? { ...item, channel: next } : item,
                ),
              );
            }}
            className="ds-input !w-auto"
            aria-label={`Reminder ${index + 1} channel`}
          >
            {CREDENTIAL_REMINDER_CHANNELS.map((channel) => (
              <option key={channel.value} value={channel.value}>
                {channel.label}
              </option>
            ))}
          </select>
          <Button
            type="button"
            variant="secondary"
            size="sm"
            onClick={() =>
              setRows((current) => removeReminderDraft(current, row.key))
            }
            aria-label={`Remove reminder ${index + 1}`}
          >
            Delete
          </Button>
        </div>
      ))}
      {rows.length < CREDENTIAL_MAX_REMINDERS ? (
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={() => setRows((current) => addReminderDraft(current))}
        >
          Add reminder
        </Button>
      ) : null}
    </div>
  );
};
